import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import Notiflix from "notiflix";

//ANT DESIGN IMPORTS
import {
  Row,
  Typography,
  Card,
  Spin,
  Form,
  Divider,
  Table,
  Col,
  Collapse,
  Tooltip,
  Button,
  Dropdown,
} from "antd";

//ANT DESIGN ICONS IMPORTS
import { LeftOutlined, DownloadOutlined } from "@ant-design/icons";

//PROJECT IMPORTS
import TopContent from "../../../../../../components/layouts/TopContent";
import { BOM } from "../../../../../../services/definedMethod";
import cnt from "../../../../../../services/definedConstant";
import "../../../../../../assets/styles/DatePicker.css";
import MainLayout from "../../../../../../components/layouts/MainLayout";
import { apiConfig, labelConfig, staticConfig } from "../../../../group.config";
import { rightAction } from "../../../../../../redux/actions";

const { Text, Title } = Typography;
const { Panel } = Collapse;

const HoldAccount = (props) => {
  //DECLARED VARIABLES
  const { userData, rightAction } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const { state } = useLocation();
  const [useForm] = Form.useForm();
  const [accountDetails, setAccountDetails] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getGroupDetailById();
  }, []);

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
    },
    {
      title: "Account Number",
      dataIndex: "accountNo",
    },
    {
      title: "Reasons	",
      dataIndex: "reasons",
    },
    {
      title: "Date",
      dataIndex: "date",
    },
    {
      title: "Amount",
      dataIndex: "amount",
    },

    {
      title: "Actions",
      render: (_, record) => (
        <>
          {record.isReleased ? (
            <Text
              style={{
                marginTop: "auto",
                marginBottom: "auto",
                fontSize: 15,
              }}
            >
              Amount Released
            </Text>
          ) : (
            <Tooltip title={`Release Fund`}>
              <Button
                type="primary"
                icon={<DownloadOutlined />}
                shape="round"
                size="small"
                className="of-primaryBtnColor"
                onClick={() => handleOnReleaseFund(record.id)}
              />
            </Tooltip>
          )}
        </>
      ),
    },
  ];

  const getGroupDetailById = () => {
    const params = {
      associations: "all",
    };
    const url = `${apiConfig.SavingsAccounts}/${state.parentGSIMApplicationId}`;

    let body = {
      session,
      params,
    };
    setIsLoading(true);

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;

        let tempGsimLienArray = [];

        objDetail?.liens?.forEach((element) => {
          tempGsimLienArray.push({
            key: element?.id,
            id: element?.id,
            accountNo: objDetail.accountNo ? objDetail?.accountNo : "-",
            amount: element.amount ? element?.amount : "-",
            date: element.lienDate
              ? BOM.DateTime(element?.lienDate, "only-date")
              : "-",
            reasons: element.reason ? element?.reason : "-",
            isReleased: element.released,
          });
        });
        setAccountDetails(tempGsimLienArray);

        /**
         * STOP LOADER
         */
        setIsLoading(false);
      }
    });
  };

  function handleOnReleaseFund(amntParam) {
    setIsLoading(true);
    const params = {
      command: "releaseAmount",
    };
    const url = `${apiConfig.SavingsAccounts}/${state.parentGSIMApplicationId}/transactions/${amntParam}`;

    let body = {
      method: "POST",
      session,
      params,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, labelConfig.savingsAccountUpdatedMsg);
        getGroupDetailById();
        //STOP LOAD
        setIsLoading(false);
      }
    });
  }

  function backOnClick() {
    navigate("/detail-gsim-account", { state: state });
  }

  return (
    <MainLayout isEnableRightSidebar={true}>
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={labelConfig.holdAccount}
        pageItems={staticConfig.gsimAccountHoldBreadcrumbItems}
      />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Row
            style={{
              alignContent: "center",
            }}
          >
            <Button
              icon={<LeftOutlined />}
              type="text"
              style={{
                marginTop: "auto",
                marginBottom: "auto",
              }}
              onClick={backOnClick}
            >
              <Text
                style={{
                  marginTop: "auto",
                  marginBottom: "auto",
                  fontSize: 15,
                }}
              >
                Back
              </Text>
            </Button>
          </Row>

          <Divider orientation="left" orientationMargin="0">
            <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
              {`Account No: ${state.childAccountNo}`}
            </Title>
          </Divider>
          <Form
            form={useForm}
            layout="vertical"
            style={{ paddingTop: 20, marginBottom: 50 }}
          >
            <Divider style={{ marginTop: 10 }} />
            <Table
              columns={columns}
              dataSource={accountDetails}
              bordered
              pagination={{
                position: "bottomCentre",
              }}
            />
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});
const mapDispatchToProps = { rightAction };

export default connect(mapStateToProps, mapDispatchToProps)(HoldAccount);
